import { useRouter } from "@tanstack/react-router";
import Aurora from "@/components/ui/aurora";
import ChevronButton from "@/components/ui/chevron-button";

export default function ErrorComponent({ error }: { error: Error }) {
	const router = useRouter();

	return (
		<div className="relative flex min-h-dvh items-center justify-center overflow-hidden bg-orange px-4">
			<meta name="robots" content="noindex" />
			{/* Top Aurora */}
			<div className="absolute inset-0">
				<Aurora
					colorStops={["#FF5C00", "#FA8128", "#FF5C00"]}
					blend={0.4}
					amplitude={1.0}
					speed={0.5}
				/>
			</div>

			{/* Bottom Aurora (inverted) */}
			<div className="absolute inset-0 scale-y-[-1]">
				<Aurora
					colorStops={["#FF5C00", "#FA8128", "#FF5C00"]}
					blend={0.5}
					amplitude={1.0}
					speed={0.7}
				/>
			</div>

			{/* Glass Card */}
			<div className="relative z-10 flex w-full max-w-sm flex-col items-center justify-center space-y-4 rounded-2xl border border-white/20 bg-white/10 p-6 text-center shadow-xl backdrop-blur-lg sm:max-w-md sm:space-y-5 sm:p-10 md:max-w-lg">
				<h1
					className="
						font-bold text-white drop-shadow-lg leading-none
						text-[clamp(3rem,10vw,8rem)]
					"
				>
					Error
				</h1>

				<p className="text-sm text-white opacity-80 sm:text-base md:text-lg max-w-xs sm:max-w-sm">
					Something went wrong.
				</p>

				{error.message && (
					<div className="w-full rounded bg-black/20 p-4 text-left overflow-auto max-h-48">
						<code className="text-xs text-white/80 font-mono wrap-break-word">
							{error.message}
						</code>
					</div>
				)}

				<button
					type="button"
					onClick={() => router.invalidate()}
					className="focus:outline-none"
				>
					<ChevronButton
						text="Try Again"
						variant="secondary"
						className="rounded-full"
					/>
				</button>
			</div>
		</div>
	);
}
